"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.novasolfeatureIcons = exports.featureIcons = void 0;
const serviceFeatureIcons = new Map([
    ['6734', 'Wheelchair'],
    ['10315', 'ShowerBathroom'],
    ['10311', 'Bed'],
    ['10309', 'RampLevelAccessAccessible'],
    ['10313', 'GrabRailsAccessible'],
    ['10301', 'ShowerBathroom'],
    ['10303', 'HoistCraneAccessible'],
    ['10317', 'LowWorktopsKitchenAccessible'],
    ['10305', 'ShowerBathroom'],
    ['10295', 'ShowerBathroomBathWashCleanWater'],
    ['7070', 'BabyChildToddler'],
    ['6185', 'BarbecueBbqGrill'],
    ['10961', 'CelebrationPartyHouse'],
    ['10424', 'PlaygroundPlayAreaKidsChildrenSwing'],
    ['10483', 'CameraFilmMovie'],
    ['10089', 'LighthouseCoastCoastal'],
    ['10090', 'LighthouseCoastCoastal'],
    ['10091', 'LighthouseCoastCoastal'],
    ['8821', 'CotCrib'],
    ['10638', 'AwardTrophyBadge'],
    ['6194', 'BicycleBikeCycleCycling'],
    ['6788', 'ChristmasXmasDecorations'],
    ['6248', 'HolidayParkHomeHouseLodge'],
    ['6275', 'Dishwasher'],
    ['13023', 'EcoLeaf'],
    ['10839', 'ElectricVehicleChargingPoint'],
    ['6392', 'GardenPatioEnclosedTreeFence'],
    ['9198', 'Fishing'],
    ['6419', 'GamingGamesRoomController'],
    ['6401', 'GardenPatioEnclosedTreeFence'],
    ['9355', 'GroundFloorAccommodationPropertyHome'],
    ['6284', 'GroundFloorAccommodationPropertyHome'],
    ['6473', 'GroupedPropertiesComplexComplexes'],
    ['10482', 'Gym'],
    ['6428', 'HighChairBaby'],
    ['9757', 'HistoryHistoricHeritage'],
    ['6572', 'HorseRiding'],
    ['6464', 'HotTubHottubWhirlpool'],
    ['10380', 'HotTubHottubWhirlpool'],
    ['10381', 'HotTubHottubWhirlpool'],
    ['6948', 'Wifi'],
    ['9153', 'DiamondLuxuryGem'],
    ['9361', 'NewlyListedPropertyClean'],
    ['6536', 'FireplaceStoveWoodburner'],
    ['2562', 'FireplaceStoveWoodburner'],
    ['10408', 'CarPark'],
    ['11182', 'Pet'],
    ['9244', 'Pet'],
    ['6554', 'Pet'],
    ['9161', 'SwimmingPoolSwim'],
    ['9163', 'SwimmingPoolSwim'],
    ['9164', 'SwimmingPoolSwim'],
    ['9167', 'SwimmingPoolSwim'],
    ['9166', 'SwimmingPoolSwim'],
    ['6455', 'BeerPubBar'],
    ['6581', 'RomanceRomanticHeartLoveHomeHouse'],
    ['6590', 'HolidayParkHomeHouseLodge'],
    ['10418', 'SteamSaunaRoom'],
    ['6482', 'SeaCoastCoastal'],
    ['10820', 'ShowerBathroomBathWashCleanWater'],
    ['6644', 'StairgateBaby'],
    ['10481', 'SteamSaunaRoom'],
    ['6698', 'RoofThatched'],
    ['11304', 'RailTrainRailwayTransport'],
    ['10977', 'UniqueCottages'],
    ['9181', 'LaundryWashingMachine'],
    ['10966', 'SeaCoastCoastal'],
    ['6743', 'FireplaceStoveWoodburner'],
    ['9188', 'WorkingFarmBarn'],
]);
const siteFeatureIcons = new Map([
    ['3032', 'SwimmingPoolSwim'],
    ['3034', 'SwimmingPoolSwim'],
    ['3038', 'Gym'],
    ['3042', 'SteamSaunaRoom'],
    ['3044', 'Coffee'],
    ['3046', 'RestaurantMealDiner'],
    ['3048', 'WinePubBar'],
    ['3050', 'EntertainmentFamilyPassTicket'],
    ['3052', 'PlaygroundPlayAreaKidsChildrenSwing'],
    ['3056', 'PlaygroundPlayAreaKidsChildrenSwing'],
    ['3062', 'Grapes'],
    ['3064', 'LaundryWashingMachine'],
    ['3070', 'BeachCoastSea'],
    ['3072', 'Golf'],
    ['3074', 'Fishing'],
    ['3222', 'SpaHealth'],
    ['3445', 'NewlyListedPropertyClean'],
    ['3732', 'Wifi'],
    ['9188', 'WorkingFarmBarn'],
    ['9281', 'LighthouseCoastCoastal'],
    ['9317', 'Fishing'],
    ['9861', 'BeachCoastSea'],
    ['10089', 'LighthouseCoastCoastal'],
    ['10090', 'LighthouseCoastCoastal'],
    ['10902', 'SeaCoastCoastal'],
    ['10938', 'Golf'],
    ['12989', 'NewlyListedPropertyClean'],
    ['12991', 'NewlyListedPropertyClean'],
]);
exports.featureIcons = new Map([
    ...siteFeatureIcons,
    ...serviceFeatureIcons,
]);
exports.novasolfeatureIcons = new Map([
    ['309-1', 'PlaygroundPlayAreaKidsChildren'],
    ['309-2', 'SwimmingPoolSwim'],
    ['309-4', 'Golf'],
    ['309-5', 'Golf'],
    ['309-6', 'Golf'],
    ['309-10', 'Gym'],
    ['122-53', 'AirconSnowflakeFrostCold'],
    ['089-5', 'BabyChildToddler'],
    ['013-1', 'BarbecueBbqGrill'],
    ['045-1', 'CoffeeMachine'],
    ['046-4', 'CoffeeMachine'],
    ['045-1', 'CoffeeMachine'],
    ['046-4', 'CoffeeMachine'],
    ['011-5', 'GardenPatioEnclosedTreeFence'],
    ['011-3', 'GardenPatioEnclosedTreeFence'],
    ['011-1', 'GardenPatioEnclosedTreeFence'],
    ['084-3', 'Landscape3'],
    ['084-1', 'Landscape3'],
    ['084-2', 'SeaCoastCoastal'],
    ['016-3', 'BarbecueBbqGrill'],
    ['016-4', 'BarbecueBbqGrill'],
    ['010-2', 'FlowerGarden'],
    ['010-3', 'FlowerGarden'],
    ['010-4', 'Landscape3'],
    ['011-6', 'GardenPatioEnclosedTreeFence'],
    ['011-2', 'GardenPatioEnclosedTreeFence'],
    ['058-2', 'FireplaceStoveWoodburner'],
    ['058-3', 'FireplaceStoveWoodburner'],
    ['087-3', 'Landscape3'],
    ['086-3', 'Landscape3'],
    ['014-7', 'CarParkingAlt'],
    ['014-1', 'CarParkingAlt'],
    ['014-2', 'CarParkingAlt'],
    ['099-1', 'Pet'],
    ['097-2', 'Pet'],
    ['099-2', 'PetPetsPawProhibitedBanned'],
    ['023-1', 'SteamSaunaRoom'],
    ['023-1', 'SteamSaunaRoom'],
    ['023-4', 'SteamSaunaRoom'],
    ['087-1', 'BeachCoastSea'],
    ['086-5', 'BeachCoastSea'],
    ['086-4', 'BeachCoastSea'],
    ['087-1', 'BeachCoastSea'],
    ['086-8', 'BeachCoastSea'],
    ['087-6', 'Landscape4'],
    ['087-5', 'Landscape4'],
    ['087-2', 'Landscape3'],
    ['020-3', 'SwimmingPoolSwim'],
    ['020-2', 'SwimmingPoolSwim'],
    ['020-9', 'SwimmingPoolSwim'],
    ['020-1', 'SwimmingPoolSwim'],
    ['053-6', 'Tv'],
    ['053-9', 'Tv'],
    ['053-8', 'Tv'],
    ['053-5', 'Tv'],
    ['053-3', 'Tv'],
    ['048-2', 'LaundryWashingMachine'],
    ['048-2', 'LaundryWashingMachine'],
    ['048-4', 'LaundryWashingMachine'],
    ['048-2', 'LaundryWashingMachine'],
    ['058-1', 'FireplaceStoveWoodburner'],
    ['058-7', 'FireplaceStoveWoodburner'],
]);
//# sourceMappingURL=featureIcons.js.map